export const customerSettings = {
COMPANY_CODE: "mywayb2b",
ENV: "production",
VERSION: 1.1,
DOMAIN: 'myway.be',
SCRIPTS: [],
FONTS: [],
SENTRY_DSN: "",
LANGUAGES: ['nl', 'fr'],
FORCE_SINGLE_LANGUAGE_IN_URL: false,
WEBSITE_NAME: "",
IMAGE_PROMO_POSITION: "",
PATH_PREFIX: "/business",
EMPLOYEE_LOGIN: 'https://dieteren-automotive.expert4.autralis.center/login',CHECKOUT_DOMAIN:' https://mywaylease.checkout.digex.be',CHECKOUT_KEY: 'salesCheckoutLease',
GOOGLE_ANALYTICS_IDENTIFICATION: '',
GOOGLE_ANALYTICS_ID: '',
GOOGLE_SEARCH_CONSOLE_SITE_VERIFICATION: 'wm67dxt19WgSsmQjVfJoi0VWjqA-QVh9oxj2r4z1vM4',
GOOGLE_TAG_MANAGER_ID: 'GTM-5HSG9RH',
GDDL_ID: 'GTM-5HSG9RH',
HOTJAR_ID: '',
MAPBOX_TOKEN: 'pk.eyJ1IjoiYXV0cmFsaXMiLCJhIjoiY2toeXR2emhwMDk0OTJ6cWh0Y3JjeG5kaSJ9.YCvAWa5Wyqof0wPdueve5w',
RECAPTCHA_KEY: '6LcZyaUZAAAAAOrMBxDUfdVDq2xKcHORceibmov3',
INTERCOM_ID: '',
FINANCING: true,
FINANCING_SETTINGA: 'Example',
FINANCING_TEXT: true,
RESERVATION: false,
FAVORITES: true,
VEHICLE_COMPARE: true,
SEO: true,
CONSENT: false,
CONSENT_SCRIPT_URL: '//cmp.myway.be/dieteren/myway_prod/Bootstrap.js',
CONSENT_COOKIE_NAME: 'DIETEREN_ENSIGHTEN_PRIVACY_Analysis_and_Personalization',
ACCOUNT: true,
BLOG: true,
FAQ: true,
PURCHASE: true
};